"use client";

import { useState } from "react";
import { usePathname } from "next/navigation";
import posthog from "posthog-js";
import {
  capturePostHogEvent,
  capturePostHogException,
} from "@/lib/posthog-capture";
import { useAuthFlowErrorTracker } from "@/hooks/use-auth-flow-error-tracker";

function getAuthFlowSessionId(): string {
  try {
    const sessionId = posthog.get_session_id?.();
    if (sessionId) {
      return sessionId;
    }
  } catch {
    // Keep a local id if PostHog has not assigned one yet.
  }
  try {
    const existing = sessionStorage.getItem("ap_auth_flow_session");
    if (existing) {
      return existing;
    }
    const created = crypto.randomUUID();
    sessionStorage.setItem("ap_auth_flow_session", created);
    return created;
  } catch {
    return crypto.randomUUID();
  }
}

export function AuthFlowErrorTracker() {
  const pathname = usePathname();
  const [sessionId] = useState(getAuthFlowSessionId);

  useAuthFlowErrorTracker({
    pathname,
    sessionId,
    captureEvent: capturePostHogEvent,
    captureException: capturePostHogException,
  });

  return null;
}
